import Vue from 'vue';
import Router from 'vue-router';
import mainElement from './vue/mainElement.vue';
import shareElement from './vue/shareElement.vue';
import shareRetailerElement from './vue/shareRetailerElement.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: app.vue_router.lang_slug,
            name: app.vue_router.home_name,
            component: mainElement,
            meta: {
                bg: '#f6e9dc'
            },
        },
        {
            path:  app.vue_router.lang_slug + 'share',
            name: app.vue_router.share_name,
            component: shareElement,
            meta: {
                back: true,
                bg: '#f6e9dc'
            },
        },
        {
            path: app.vue_router.lang_slug + 'share-with-retailer',
            name: app.vue_router.share_retailer_name,
            component: shareRetailerElement,
            meta: {
                back: true,
                bg: '#f3f2f2'
            },
        },
    ],
});
